import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { setSelectedReport } from '../../../redux/actions/select'

import {
  Grid, Fab, Paper, FormLabel, Collapse, List, ListItem, ListItemIcon, ListItemText, Typography
} from '@material-ui/core'

import {
  Web as TopWebsitesIcon, AssignmentInd as TopUsersIcon, VpnKey, AssignmentLate as TopPhrasesIcon,
  SupervisedUserCircle, Ballot, ExpandMore, ExpandLess
} from '@material-ui/icons'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  customText: {
    textTransform: 'none !important',
    marginTop: '1rem'
  },
  navBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    },
    borderRadius: '50%',
    width: '45px',
    height: '45px'
  },
  icon: {
    fontSize: '2rem'
  },
  reportButtonText: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: 'grey'
  }
}))

const ReportsButtonContainer = (props) => {
  // Determine whether the supervisor has permissions to view the supervisor activity report; if so, then include the report link.
  const userPermissions = useSelector(state => state.auth.permissions)
  const viewPermission = userPermissions && userPermissions.length ? userPermissions.includes('supervisor-report-viewer') : false
  const dispatch = useDispatch()
  const classes = useStyles()

  const [usersOpen, setUsersOpen] = useState(false)
  const [supervisorOpen, setSupervisorOpen] = useState(false)

  // const SelectedReport = useSelector(state => state.selection.Report)

  return (
    <>
      <Grid container item direction='column' justify='flex-start' xs={11}>
        <Paper elevation={2} style={{ paddingBottom: '2em' }}>
          <Grid
            container
            direction='column'
            justify='center'
            className='w-100 mx-auto my-auto'
          >
            <Grid item container direction='row' justify='center' style={{ marginTop: '3em' }}>
              <Grid item container direction='column' style={{ cursor: 'pointer' }} onClick={(e) => setUsersOpen(open => !open)}>
                <Grid item container direction='row' justify='center' alignItems='center'>
                  <Fab
                    className={classes.navBtn}
                  >
                    <TopUsersIcon className={classes.icon} />
                  </Fab>
                  {usersOpen ? <ExpandLess style={{ color: 'grey' }} /> : <ExpandMore style={{ color: 'grey' }} />}
                </Grid>
                <Grid item container direction='row' justify='center' style={{ marginTop: '.5rem', padding: '.5em 1em', textAlign: 'center' }}>
                  <FormLabel className={classes.reportButtonText}>User Reports</FormLabel>
                </Grid>
              </Grid>
            </Grid>

            <Collapse in={usersOpen} unmountOnExit>
              <Grid item container direction='row' justify='center'>
                <List style={{ paddingTop: 0 }}>
                  <ListItem
                    button
                    style={{ fontWeight: 900, padding: 0 }}
                    onClick={(e) => { e.preventDefault(); dispatch(setSelectedReport('users')) }}
                  >
                    <ListItemIcon style={{ minWidth: '2em' }}>
                      <TopUsersIcon style={{ fontSize: '18px' }} />
                    </ListItemIcon>
                    <ListItemText primary={<Typography variant='subtitle1' style={{ fontWeight: 'bold', color: 'grey' }}>User</Typography>} />
                  </ListItem>
                  <ListItem
                    button
                    style={{ fontWeight: 900, padding: 0 }}
                    onClick={(e) => { e.preventDefault(); dispatch(setSelectedReport('phrases')) }}
                  >
                    <ListItemIcon style={{ minWidth: '2em' }}>
                      <TopPhrasesIcon style={{ fontSize: '18px' }} />
                    </ListItemIcon>
                    <ListItemText primary={<Typography variant='subtitle1' style={{ fontWeight: 'bold', color: 'grey' }}>Phrases</Typography>} />
                  </ListItem>
                  <ListItem
                    button
                    style={{ fontWeight: 900, padding: 0 }}
                    onClick={(e) => { e.preventDefault(); dispatch(setSelectedReport('websites')) }}
                  >
                    <ListItemIcon style={{ minWidth: '2em' }}>
                      <TopWebsitesIcon style={{ fontSize: '18px' }} />
                    </ListItemIcon>
                    <ListItemText primary={<Typography variant='subtitle1' style={{ fontWeight: 'bold', color: 'grey' }}>Website</Typography>} />
                  </ListItem>
                </List>
              </Grid>
            </Collapse>

            {viewPermission &&
              <>
                <Grid item container direction='row' justify='center' style={{ marginTop: '2em' }}>
                  <Grid item container direction='column' style={{ cursor: 'pointer' }} onClick={(e) => setSupervisorOpen(open => !open)}>
                    <Grid item container direction='row' justify='center' alignItems='center'>
                      <Fab
                        className={classes.navBtn}
                      >
                        <SupervisedUserCircle className={classes.icon} />
                      </Fab>
                      {supervisorOpen ? <ExpandLess style={{ color: 'grey' }} /> : <ExpandMore style={{ color: 'grey' }} />}
                    </Grid>
                    <Grid item container direction='row' justify='center' style={{ marginTop: '.5rem', padding: '.5em 1em', textAlign: 'center' }}>
                      <FormLabel className={classes.reportButtonText}>Supervisor Reports</FormLabel>
                    </Grid>
                  </Grid>
                </Grid>

                <Collapse in={supervisorOpen} unmountOnExit>
                  <Grid item container direction='row' justify='center'>
                    <List style={{ paddingTop: 0 }}>
                      <ListItem
                        button
                        style={{ fontWeight: 900, padding: 0 }}
                        onClick={(e) => { e.preventDefault(); dispatch(setSelectedReport('supervisor-report')) }}
                      >
                        <ListItemIcon style={{ minWidth: '2em' }}>
                          <Ballot style={{ fontSize: '18px' }} />
                        </ListItemIcon>
                        <ListItemText primary={<Typography variant='subtitle1' style={{ fontWeight: 'bold', color: 'grey' }}>Activity</Typography>} />
                      </ListItem>
                      <ListItem
                        button
                        style={{ fontWeight: 900, padding: 0 }}
                        onClick={(e) => { e.preventDefault(); dispatch(setSelectedReport('supervisor-login-report')) }}
                      >
                        <ListItemIcon style={{ minWidth: '2em' }}>
                          <VpnKey style={{ fontSize: '18px' }} />
                        </ListItemIcon>
                        <ListItemText primary={<Typography variant='subtitle1' style={{ fontWeight: 'bold', color: 'grey' }}>Login</Typography>} />
                      </ListItem>
                    </List>
                  </Grid>
                </Collapse>
              </>}

          </Grid>
        </Paper>
      </Grid>
    </>
  )
}

export default withRouter(ReportsButtonContainer)
